<template>
<div v-if="msg2 !== null && msg2 !== ''" id="idMsg" class="ui centered container">
  <div class="ui icon message" id='firstRow' v-if="title2 === 'paquetes_recogidos_OK'">
    <i class="big check icon" id='iconoCheck'></i>
    <div class="ui content">
      <div class="ui header">
        <img class="ui image" id="imgPackage" src="../assets/package2.png">
      </div>
      <p>ENVIO RECOGIDO</p>
    </div>
  </div>

  <div class="ui icon message" id='firstRow' v-if="title2 === 'paquetes_recogidos_KO'">
    <i class="big times icon"></i>
    <div class="ui content">
      <div class="ui header">
        <img class="ui image" id="imgPackage2" src="../assets/package.png">
            
      </div>
      <p>INCIDENCIA EN LA RECOGIDA</p>
    </div>
  </div>

  <div class="ui icon message" id='firstRow' v-if="title2 === 'paquetes_cero'">
    <div class="ui content">
      <div class="ui header">
        <img class="ui image" id="imgPackage" src="../assets/package2.png">
      </div>
      <p>Paquetes a recoger: <b>0</b></p>
    </div>
  </div>

  <div class="ui icon message" id='firstRow' v-if="title2 !== 'paquetes_recogidos_OK' && title2 !== 'paquetes_cero'">
  </div>

  <div class="ui icon message" id="secondRow">
    <i v-if="type2 === 'info'" class="big info circle icon"></i>
    <i v-if="type2 === 'success'" class="big check icon"></i>
    <i v-if="type2 === 'error'" class="big times circle icon"></i>

    <div class="ui content" id='mensaje'>
      <div class="ui header">
        <h4 v-if="title2 && title2 !== 'null' && title2 !== 'paquetes_cero' && title2 !== 'paquetes_recogidos_OK' && title2 !== 'paquetes_recogidos_KO'">{{ title2 }} <br><br></h4>
      </div>
      <p>{{ msg2 }}</p>
    </div>
  </div>
</div>

</template>

<script>
export default {
  name: 'Messages',
  props: ['apm','codError','title','msg','type','token','closeSession'],
  data() {
    return {
      msg2: null,
      type2: null,
      title2: null,
      codError2: null
    }
  },
  created() {
    if (this.token) {
      if (this.closeSession == 1) {
        this.closeSesion(this.token);
      }
    }
    this.msgText(this.codError,this.title,this.msg,this.type);
  },
  methods: {
    closeSesion(token) {
      localStorage.clear();

      let url = this.$url_hapiick + '/v1/apms/exit';
      let headers = {
        'Content-Type': 'application/json',
        'X-Auth-Token': token,
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.post(url,{
      },
      {
        headers: headers
      })
      .then(
        this.$apm_name = ""
      )
      .catch((error) => {
        if(error.request) {
          if (error.request.status == 429) {
            this.codError2 = error.request.status
            this.msgText(this.codError2,'','','')
          } else {
            console.log(error.request)
          }
        }
      })
    },
    msgText(codError,title,msg,type) {
      if (codError === '' && msg !=='') {
        this.msg2 = msg;
        this.type2 = type;
        this.title2 = title;
      } else {
        if (codError == 405 || codError == 501 || codError == 400) {//!POST || hapiick_qr no existe o la amp no tiene este servicio 
          this.msg2 = 'Servicio NO DISPONIBLE para esta máquina.';
          this.type2 = 'info';
          this.title2 = title;
        } else if (codError == 429) { //UNAUTHORIZED
          this.msg2 = 'El acceso ha sido cancelado por seguridad. Por favor, vuelve a intentarlo en unos minutos. Disculpa las molestias. Gracias.';
          this.type2 = 'error';
          this.title2 = title;
        } else if (codError == 500) {
          this.title2 = 'ERROR INTERNO.';
          this.msg2 = 'Por favor, vuelve a intentarlo. Si persiste el problema, ponte en contacto con nosotros a traves del teléfono 934 177 199. Disculpa las molestias. Gracias.';
          this.type2 = 'error';
        } else if (codError == 401) { //UNAUTHORIZED
          this.title2 = 'SESIÓN CADUCADA.';
          //this.msg2 = 'Se ha superado el tiempo máximo de acceso. Por favor, vuelve a ESCANEAR el código QR. Disculpa las molestias. Gracias.';
          this.msg2 = 'Se ha superado el tiempo máximo de acceso. Por favor, vuelve a iniciar sesión. Disculpa las molestias. Gracias.';
          this.type2 = 'info';
        } else if (codError === '') { //Cuando el token esta vacio
          this.title2 = "OTRA OPERACIÓN EN CURSO."
          //this.msg2 = 'Por favor, vuelve a ESCANEAR el código QR en 5 minutos. Disculpa las molestias. Gracias.';
          this.msg2 = 'Por favor, espere 5 minutos y vuelve a iniciar sesión. Disculpa las molestias. Gracias.';
          this.type2 = 'info';
        } else {
          this.msg2 = 'Ha ocurrido un error. Por favor, vuelve a intentarlo.';
          this.type2 = 'error';
          this.title2 = title;
        }
      }
    },
  }
}
</script>

<style scoped>
h4 {
  margin: 0px;
}

b {
  font-size: 25px;
}

#firstRow {
  height: 30%;
  position: absolute;
  top: 10%;
  width: 90%;
}

#secondRow {
  height: 30%;
  position: absolute;
  top: 35%;
  width: 90%;
}

#imgPackage {
  width: 65px;
  margin: auto!important;
}

#imgPackage2 {
  width: 85px;
  margin: auto!important;
}

#idMsg {
  height: 80%;
  width: 100%;
}

#mensaje {
  text-align: justify;
}

#iconoCheck {
  color: #00f9a9 !important;
}

.ui.icon.message {
  margin: 0px!important;
  background-color: white!important;
  color:black!important;
  box-shadow: none;
  margin: 1em 0;
}

.paquetesOK {
  text-align: center;
  width: 90%;
  margin:auto;
}

.paquetesOK i {
  color: #00f9a9 !important;
}

.icono {
  margin: auto;
  height: 100%;
  display: flex;
}

.icono i {
  font-size: 45px!important;
  width: 100%;
}

@media screen and (min-width: 400px) and (min-height: 200px) and (max-height: 400px){   
  #firstRow {
    height: 30%;
    position: absolute;
    top: 15%;
    width: 95%;
  }

  #secondRow {
    height: 30%;
    position: absolute;
    top: 45%;
    width: 95%;
  }
}
</style>
